import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function RefundSyncedPaymentConfirmationModal({
  paymentSource,
  processorType,
  onConfirm,
  onCancel
}) {
  const getDescription = () => {
    const key = `cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.${paymentSource === 'INTEGRATION' ? 'bodyExternalSource' : 'bodyHubSpotSource'}.${processorType}`;
    if (isValidI18nKey(key)) {
      return /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "600",
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: key
          })
        })
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    "data-test-id": "refund-synced-payment-confirmation-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCancel
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [getDescription(), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.warning"
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.continueText"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.cancelText"
        })
      })]
    })]
  });
}
export default RefundSyncedPaymentConfirmationModal;